import { render, staticRenderFns } from "./TreatmentPlagueList.vue?vue&type=template&id=1c50a3a0&scoped=true&"
import script from "./TreatmentPlagueList.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlagueList.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlagueList.vue?vue&type=style&index=0&id=1c50a3a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c50a3a0",
  null
  
)

export default component.exports